export const MIN_PASSWORD_LENGTH: number = 6;
export const LOGOUT_REDIRECT: string = '/login';
export const LOGIN_REDIRECT: string = '/timeentry';
